module.exports = __webpack_public_path__ + "static/IMG_8324-c0389ae274d016d5c8920a1a2cacad52.jpg";